import React from "react";
import { connect } from "react-redux";
import Menu from "@material-ui/core/Menu";
import { NavLink, withRouter } from "react-router-dom";
import MenuItem from "@material-ui/core/MenuItem";
import { userSignOut } from "actions/Auth";
import Chip from "@material-ui/core/Chip";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { withTranslation } from "react-i18next";

import Cookies from "js-cookie";
import Axios from "actions/Axios";

class UserInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      anchorEl2: null,
      open: false,
      open2: false,
      openLogout: false,
      notification: props.data,
      totalCount: props.totalCount,
    };
  }

  handleClick = (event) => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleClick2 = (event) => {
    this.setState({ open2: true, anchorEl2: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  handleRequestClose2 = () => {
    this.setState({ open2: false });
  };

  logoutConfirmation = (state) => {
    this.setState({ openLogout: state });
  };

  userSignOut = () => {
    Axios.clearSessionCookies();

    this.props.history.push("/signin");
  };

  render() {
    const { t, data, totalCount } = this.props;
    const { openLogout, anchorEl, anchorEl2, open, open2 } = this.state;

    return (
      <div className="user-profile d-flex flex-row align-items-center" style={{ cursor: "pointer" }}>
        {/* Logout Confirmation Dialog */}
        <Dialog
          open={openLogout}
          onClose={() => this.logoutConfirmation(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{t("popup.logoutConfirm.title")}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {t("popup.logoutConfirm.description")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.userSignOut} color="primary" autoFocus>
              {t("popup.logout")}
            </Button>
            <Button onClick={() => this.logoutConfirmation(false)} color="primary">
              {t("popup.cancel")}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Notifications Icon */}
        <div className="user-detail notificationicon" onClick={this.handleClick2}>
          <i className="zmdi zmdi-notifications-active"></i>
          <span className="not-count">{totalCount}</span>
        </div>

        {/* Notification List Dropdown */}
        {totalCount > 0 && (
          <Menu
            className="user-info"
            id="notification-menu"
            anchorEl={anchorEl2}
            open={open2}
            onClose={this.handleRequestClose2}
            PaperProps={{ style: { minWidth: 200, paddingTop: 0, paddingBottom: 0 } }}
          >
            {data &&
              data.slice(0, totalCount).map((n) => (
                <MenuItem onClick={this.handleRequestClose2} key={n._id}>
                  <NavLink to="/app/orders/all">{n.message}</NavLink>
                </MenuItem>
              ))}
            <NavLink
              onClick={this.handleRequestClose2}
              className="see_more_notification"
              to="/app/notifications/list"
            >
              {t("popup.viewNotifications")}
            </NavLink>
          </Menu>
        )}

        {/* Profile Icon and Menu */}
        <div className="user-detail" onClick={this.handleClick}>
          <Chip
            style={{ cursor: "pointer" }}
            icon={<AccountCircleIcon />}
            label={Cookies.get("name")}
          />
          <i className="zmdi zmdi-caret-down zmdi-hc-fw align-middle"></i>
        </div>
        <Menu
          className="user-info"
          id="profile-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleRequestClose}
          PaperProps={{ style: { minWidth: 120, paddingTop: 0, paddingBottom: 0 } }}
        >
          <MenuItem
            onClick={() => {
              this.handleRequestClose();
              this.logoutConfirmation(true);
            }}
          >
            <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2" />
            {t("popup.logout")}
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { locale } = settings;
  return { locale };
};

export default withRouter(
  connect(mapStateToProps, { userSignOut })(withTranslation()(UserInfo))
);
